import React, { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import Logo from '../assets/img/logo1.jpg'

const NavbarComp = () => {
    const [showMenu, setShowMenu] = useState(false);
    const { pathname } = useLocation();

    const handleShowMenu = () => {
        setShowMenu(!showMenu);
    }
    
    useEffect(() => {
        setShowMenu(false);
    }, [pathname]);

  return (
    <div id='navigation_bar'>
        <div className='top-bar'>
            <ul className='quick-contact'>
                <li>
                    <a href="mailto:infojnb@twf.co.za"><i className='bi bi-envelope-fill'></i> infojnb@twf.co.za</a>
                </li>
                <li>
                    <a href="tel:+27112532600"><i className='bi bi-telephone-fill'></i> +27112532600</a>
                </li>
                <li>
                    <a href="tel:+97585287708"><i className='bi bi-phone-fill'></i> +97585287708</a>
                </li>
            </ul>

            <ul className='social-accounts'>
                <li>
                    <a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-facebook'></i></a>
                </li>
                <li>
                    <a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-instagram'></i></a>
                </li>
                <li>
                    <a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-twitter-x'></i></a>
                </li>
                <li>
                    <a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-linkedin'></i></a>
                </li>
                <li>
                    <a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-tiktok'></i></a>
                </li>
            </ul>
        </div>
        <div className='main-nav'>
            <Link to="/" className='navbar-brand'>
                <img src={Logo} alt="company logo" />
            </Link>

            <button type='button' className='burger-btn' onClick={handleShowMenu}>
                <i className='bi bi-list'></i>
            </button>

            <ul className={`menu-items ${showMenu ? 'active-menu shadow-sm' : ''}`}>
                <li>
                    <NavLink to="/">Home</NavLink>
                </li>
                <li>
                    <NavLink to="/packages">Packages</NavLink>
                </li>
                <li>
                    <NavLink to="/destinations">Destination</NavLink>
                </li>
                <li>
                    <NavLink to="/contact">Contact</NavLink>
                </li>
            </ul>
        </div>
    </div>
  )
}

export default NavbarComp